
import React, { useEffect } from 'react';
import {Link } from 'react-router-dom';
import InfoPratique  from './InfoPratique';
import SocialWall  from './SocialWall';
import Partenaires from './Partenaires';
import ProchainsMatch from './ProchainsMatchs';
import TopJoueurs from './TopJoueurs';


function Home() {

  const navbar = document.getElementById('navbar')

   useEffect(() => {
          if (navbar) {
            navbar.classList.remove('page');
          }
    }, []);

  return(
    <div>
      <div className="container-cover">
        <div className='cover-txt'>
        <h1>Vous souhaitez rejoindre le club du TTBriançon ?</h1>
        <Link className="btn btn-primary" to="/contact">Contactez-nous</Link>
        </div>
      </div>
      <InfoPratique/>
      <ProchainsMatch/>
      <TopJoueurs/>
      <SocialWall/>
      <Partenaires/>


    </div>
  )
}

export default Home;